import { render, staticRenderFns } from "./store-hotsale.vue?vue&type=template&id=27d0490e&scoped=true"
import script from "./store-hotsale.vue?vue&type=script&lang=js"
export * from "./store-hotsale.vue?vue&type=script&lang=js"
import style0 from "./store-hotsale.vue?vue&type=style&index=0&id=27d0490e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d0490e",
  null
  
)

export default component.exports